import { useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';

const AppointmentForm = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    partySize: 1,
    specialRequests: ''
  });
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const response = await axios.post('https://reservation-backend-634485963533.us-west1.run.app/api/reservations', formData);
      console.log('Appointment created:', response.data);
      
      setFormData({
        name: '',
        email: '',
        phone: '',
        date: '',
        time: '',
        partySize: 1,
        specialRequests: ''
      });
      
      if (onSuccess) onSuccess();
      alert('Appointment created successfully! We will contact you soon to confirm.');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create appointment');
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="max-w-md mx-auto w-full"
    >
      <div className="bg-white dark:bg-slate-800 rounded-2xl p-8 shadow-xl border border-sky-200 dark:border-blue-700">
        <h2 className="text-2xl font-bold text-sky-700 dark:text-sky-300 mb-6">
          Schedule Your Appointment
        </h2>
        
        {error && (
          <div className="bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 p-3 rounded-lg mb-4">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-sm font-medium text-sky-700 dark:text-sky-300 block mb-2">
              Name *
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 rounded-lg border border-sky-300 dark:border-blue-600 bg-sky-50 dark:bg-slate-700 text-slate-900 dark:text-sky-100 focus:outline-none focus:ring-2 focus:ring-sky-500"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-sky-700 dark:text-sky-300 block mb-2">
              Email *
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 rounded-lg border border-sky-300 dark:border-blue-600 bg-sky-50 dark:bg-slate-700 text-slate-900 dark:text-sky-100 focus:outline-none focus:ring-2 focus:ring-sky-500"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-sky-700 dark:text-sky-300 block mb-2">
              Phone *
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 rounded-lg border border-sky-300 dark:border-blue-600 bg-sky-50 dark:bg-slate-700 text-slate-900 dark:text-sky-100 focus:outline-none focus:ring-2 focus:ring-sky-500"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium text-sky-700 dark:text-sky-300 block mb-2">
                Date *
              </label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 rounded-lg border border-sky-300 dark:border-blue-600 bg-sky-50 dark:bg-slate-700 text-slate-900 dark:text-sky-100 focus:outline-none focus:ring-2 focus:ring-sky-500"
              />
            </div>

            <div>
              <label className="text-sm font-medium text-sky-700 dark:text-sky-300 block mb-2">
                Time *
              </label>
              <input
                type="time"
                name="time"
                value={formData.time}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 rounded-lg border border-sky-300 dark:border-blue-600 bg-sky-50 dark:bg-slate-700 text-slate-900 dark:text-sky-100 focus:outline-none focus:ring-2 focus:ring-sky-500"
              />
            </div>
          </div>

          <div>
            <label className="text-sm font-medium text-sky-700 dark:text-sky-300 block mb-2">
              Service Needed
            </label>
            <textarea
              name="specialRequests"
              value={formData.specialRequests}
              onChange={handleChange}
              rows="3"
              placeholder="e.g., Chimney cleaning, inspection, repair..."
              className="w-full px-4 py-2 rounded-lg border border-sky-300 dark:border-blue-600 bg-sky-50 dark:bg-slate-700 text-slate-900 dark:text-sky-100 focus:outline-none focus:ring-2 focus:ring-sky-500"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 px-6 rounded-lg bg-gradient-to-r from-sky-500 to-blue-600 text-white font-medium hover:from-sky-600 hover:to-blue-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg"
          >
            {loading ? 'Submitting...' : 'Book Appointment'}
          </button>
        </form>
      </div>
    </motion.div>
  );
};

export default AppointmentForm;
